import makeRequest from "../../../makeRequest";

const url = "/api/user/appointmentType";

export async function listConsultationTypes(id: string) {
    return makeRequest("GET", `${url}/list/${id}`);
}
